import { handleApi } from "..";
import {
    APPROVE_SUMMIT_PAYMENT,
    SUMMIT_PAYMENTS,
} from "../../constants/api_constants";

export const allSummitPayments = async () => {
    return handleApi("get", SUMMIT_PAYMENTS);
};

export const approveSummitPayment = async (id, notes) => {
    return handleApi("post", `${APPROVE_SUMMIT_PAYMENT}/${id}/approve`, {
        notes,
    });
};